import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from "@angular/core";

import { Subscription } from "rxjs";
import { MenuItems, PrimaryMenuItems } from "../../../core/constants/menu";
import { LogoPath, UserimgPath } from "../../../core/constants/image";
import { LoginLink, UserType } from "../../../core/constants/common";
import {
  AuthService, SharedVarService, CommonService,
  SnackService, User, DateTimeService, ProviderService
} from "@school/a2z-lib";
import { Router } from "@angular/router";


@Component({
  selector: "school-aside",
  templateUrl: "./aside.component.html",
  styleUrls: ["./aside.component.scss"]
})
export class AsideComponent implements OnInit, OnDestroy {

  fullName: any;
  asideClasses = '';
  designation = '';
  userimg = '';
  selectedmenuvalue: string;
  signoutlink = LoginLink;
  logovalue = LogoPath;
  Menulists: any = MenuItems;
  userSub: Subscription;
  chkGender: string;
  defaultAvatar: string = 'blank.png';

  @Output() menuEvent = new EventEmitter<string>();

  constructor(private authService: AuthService,
    private _userService: CommonService,
    private _providerService: ProviderService,
    private _snackService: SnackService,
    private router: Router,
    private _dateTimeService: DateTimeService,
    private SharedVarservice: SharedVarService) {
  }

  ngOnInit() {
    this.fullName = 'Name';
    this.designation = 'Provider Admin';
    this.profileImg();
    // this.getProvidersProfile();

    this.SharedVarservice.getValue().subscribe((value) => {
      if (typeof (value) == 'boolean') {
        if (value) {
          this.LoadData();
        }
      }
    });
    // this.LoadData();
      const storageKey=JSON.parse(localStorage.getItem('userData'))
      // const storageKeyU=JSON.parse(localStorage.getItem('userData_admin'))
      console.log(storageKey)


    this.userSub = this.authService.user.subscribe(user => {

      if (!user) {
        return;
      }
      else  if (storageKey.role === 'client'){

   this.router.navigate(['/forms']);
    return; 

     
    // console.log('User is a CLIENT. Apply specific client logic here.');
    // You can redirect, load specific menu, or set flags

      }
      console.log(user,'useruser')

      this.fullName = user.name;
      this.designation = user.role;


      if (user.profileImage) {
        this.userimg = 'url(' + user.profileImage + ')';
      }
    });

    this.Menulists.forEach(element => {

      console.log(element.urlLink,element.title)
      console.log(this.router.url.includes(element.urlLink))

      if (this.router.url.includes(element.urlLink)) {
        this.Menuclick(element.title);
      }
    });

  }


  profileImg() {
    this.userSub = this.authService.user.subscribe(user => {
      console.log(user,'user')


      this.chkGender = user.gender;
      if (this.chkGender.toLowerCase() == 'female') {
        this.defaultAvatar = 'woman.png';
      }

      if (this.chkGender.toLowerCase() == 'male') {
        this.defaultAvatar = 'man.png';
      }
      this.userimg = 'url(' + UserimgPath + this.defaultAvatar + ')';
    });
  }

  LoadData() {

    this._userService.getLoginUserInfos().subscribe(
      result => {


        const userData: {
          name: string;
          last_name: string;
          email: string;
          profileImage: string;
          gender: string;
          role: string;
          timezone: any;
          is2fa: boolean;
          _token: string;
          _tokenExpirationDate: Date;
        } = JSON.parse(localStorage.getItem('userData' + UserType));
        this.fullName = result.body.data.first_name + ' ' + result.body.data.last_name;

        if (result.body.data.profile_image) {
          this.userimg = 'url(' + result.body.data.profile_image + ')';
        }

        userData.name = result.body.data.first_name + ' ' + result.body.data.last_name;
        userData.email = result.body.data.email;
        userData.profileImage = result.body.data.profile_image;
        userData.timezone = result.body.data.timezone;
        userData.gender = result.body.data.gender;

        const user = new User(
          userData.name,
          userData.last_name,                // 🧱 Missing before
          userData.email,
          userData.profileImage,
          userData.gender,
          userData.role,
          userData.timezone,
          userData.is2fa,                    // 🧱 Missing before
          userData._token,
          userData._tokenExpirationDate
        );
        this.authService.user.next(user);
        this._dateTimeService.format = this._dateTimeService.getFormat();

        localStorage.setItem('userData' + UserType, JSON.stringify(userData));
        if (!result.body.data.profile_image) {
          this.profileImg();
        }

      }, error => {
        this._snackService.openSnackBar("danger", "Failed to Load updated data..");
      });

  }

  ngOnDestroy() {
    this.userSub.unsubscribe();
  }

  Menuclick(menutitle) {
    this.menuEvent.emit(menutitle);
  }

  identify(index, item) {
    return item.id;
  }

  getProvidersProfile() {

    this._providerService.getProvidersProfile().subscribe(
      result => {
        if (result.body.data.primary_provider_id) {
          this.Menulists = MenuItems;
        } else {
          this.Menulists = PrimaryMenuItems;
        }
      }, error => {
        console.log(error);
      });
  }


}
